/**
 * Module dependencies.
 */

import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';
import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { AxiosInstance } from 'axios';
import { useQuery } from '@tanstack/react-query';
import { Sale } from 'app/types/sale';

/**
 * Get sale detail.
 */

export function getSaleDetail(client: AxiosInstance, id: string, userId?: string): Promise<Sale> {
  // If userId is provided, use the user-specific endpoint
  const endpoint = userId ? 'userSalesById' : 'salesById';
  const interpolations = userId ? { userId, id } : { id };

  return client
    .get(
      resolveAppUrl(endpoint, {
        interpolations
      }),
      { withCredentials: true }
    )
    .then(({ data }) => data?.data);
}

/**
 * Export `useGetSaleDetail`.
 */

export function useGetSaleDetail(id: string | undefined, userId?: string | undefined) {
  const client = useRequestProvider();

  return useQuery(['sales', userId, id], {
    queryFn: async () => {
      if (!id) {
        return null;
      }

      return getSaleDetail(client, id, userId);
    }
  });
}
